module.exports = __webpack_public_path__ + "static/media/jsfk_swiper.5ea72ed6.jpg";